import { cn } from '@workspace/lib';
import { Typography } from '@/app/common';

interface GalleryHeaderProps {
  headingText: string;
}

export const GalleryHeader = ({ headingText }: GalleryHeaderProps) => {
  if (!headingText) return null;

  return (
    <Typography
      variant="h4"
      className={cn('md:w-51.75! md:pr-0 pr-14.5 text-primary md:mx-0 font-bold')}
      styleVariant="h5"
    >
      {headingText}
    </Typography>
  );
};
